import { TERMS_OF_USE } from './terms'
import { PRIVACY_POLICY } from './privacy'

export const SIDEBAR_MENU = [TERMS_OF_USE, PRIVACY_POLICY]

export { TERMS_OF_USE, PRIVACY_POLICY }
